import {Pipe, PipeTransform, Inject} from '@angular/core';
import {BringozWeightPipe} from './bringoz-weight.pipe';

@Pipe({
  standalone: false,
  name: 'servicePackageWeight'
})
export class ServicePackageWeightPipe implements PipeTransform {

  constructor(
    @Inject('splitService') private splitService,
    @Inject(BringozWeightPipe) private bringozWeightPipe: BringozWeightPipe
  ) {
  }

  transform(packageItems: any[], enableUnitDisplay: boolean): string {
    if (!packageItems) {
      return '---';
    }
    const countAsTotal = this.splitService.getPackageWeightIsTotal();

    const itemsWeightSum = packageItems.reduce((sum, i) => {
      const itemWeight = i.weight || 0;
      return countAsTotal ? sum + itemWeight : sum + itemWeight * (i.count || 0);
    }, 0);

    return itemsWeightSum
      ? this.bringozWeightPipe.transform(itemsWeightSum, enableUnitDisplay)
      : '--';
  }
}
